<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{sidebarHeader}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings" id="sceneContent">
      <div class="pl-6 pr-6 pb-6">
        <div>
          <label ref="nameLabel">Name</label>
          <vs-input autocomplete="off" v-validate="'required'" name="Name" v-model="formData.name" class="w-full" />
          <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
        </div>

        <div class="pt-4 pb-2">
          <label>Description</label>
          <vs-textarea name="Description" v-model="formData.description" class="w-full" />
        </div>

        <vs-divider>Background Image Settings</vs-divider>
        <label>Background Image</label>
        <vs-select placeholder="Search / Select Background" class="w-full pb-5" vs-multiple autocomplete v-model="formData.backgroundId">
          <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in backgrounds" />
        </vs-select>

        <vs-divider>Background Music Settings</vs-divider>
        <label>Background Music</label>
        <vs-select placeholder="Search / Select Music" class="w-full pb-5 cursor-pointer" vs-multiple autocomplete v-model="formData.musicId">
          <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in music" />
        </vs-select>

        <div class="pt-2 pb-4">
          <label>Start Playing At</label>
          <vs-input-number v-model="formData.musicPosition" min="0" label="Seconds:" class="float-center" />
        </div>

        <div class="pt-6">
          <vs-button v-show="formData.id" class="w-full cursor-pointer" color="primary" type="border" icon-pack="feather" icon="icon-play" target :href="previewUrl">Preview</vs-button>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="updateApproach" :disabled="isDisabled" ref="addupdateButton">{{buttoncaption}}</vs-button>
      <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" v-show="formData.id" @click="deleteScene" ref="deleteButton">Delete</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    selectedScene: {
      type: Object,
      required: false
    },
     buttoncaption: {
      type: String,
      required: false
    },
    sidebarHeader: {
      type: String,
      required: false
    },
  },

  data() {
    return {
      backgroundLoading:'#fff',
      formData: {
        id: 0,
        name: "",
        description: "",
        backgroundId: "",
        musicId: "",
        musicPosition: 0,
        isUsedByDialog: false,
        isUsedByVideo: false,
        isUsedByNavigation: false
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      music:[],
      backgrounds:[]
    };
  },
  computed: {
    previewUrl:{
     get() {
        return '../courseviewer/courseviewer?mode=previewScene&sceneId='+ this.formData.id ;
      }, 
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    },
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
    isDisabled: function(){
     return false;
    }
  },
  watch: {
    isSidebarActive: function(val) {
      if(val){
        var self = this;

        var onMusicSuccess = response => { self.music = response.data; };
        var onImageSuccess = response => { self.backgrounds = response.data; };

        self.$ajaxGet(self, "music/GetSelectList", onMusicSuccess);
        self.$ajaxGet(self, "background/GetSelectList", onImageSuccess);

        if(this.selectedScene.id)
        {
          this.formData.id = this.selectedScene.id;
          this.formData.name = this.selectedScene.name;
          this.formData.description = this.selectedScene.description;
          this.formData.backgroundId = this.zeroIfEmpty(this.selectedScene.backgroundId);
          this.formData.musicId = this.selectedScene.musicId;
          this.formData.musicPosition = this.zeroIfEmpty(this.selectedScene.musicPosition);
          this.formData.isUsedByDialog = this.selectedScene.isUsedByDialog;
          this.formData.isUsedByVideo = this.selectedScene.isUsedByVideo;
          this.formData.isUsedByNavigation = this.selectedScene.isUsedByNavigation;
        } else {
          this.initValues();
        }
      }else {
        var options = {
          container: '#sceneContent',
          easing: 'ease-in',
          offset: -1000,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(this.$refs["nameLabel"], 500, options);
      }
    }
  },
  methods: {
    initValues() {
      this.formData.name = "";
      this.formData.description = "";
      this.formData.backgroundId = "";
      this.formData.musicId = "";
      this.formData.id = 0;
      this.formData.musicPosition = 0;
      this.errors.clear();
    },
    saveData(){
     this.$emit('saveData');
     this.$vs.loading.close(this.$refs.addupdateButton.$el);
    },
    addEditScene() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if(self.formData.backgroundId){
          if (result) {
          self.showLoadingOnButton();
          if(self.formData.isUsed)
            self.showLoadingOnList();

          var onSuccess = response => {
            this.saveData();
            self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Scene Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
            });
          };
          var onFinally = function (){
            self.$vs.loading.close(self.$refs.addupdateButton.$el);
            self.$vs.loading.close(self.$parent.$el);
          };
          
          self.$ajaxPost(self, "scene", self.formData, onSuccess, onFinally);
          } else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        }
        else{
          self.$vs.notify({
            title:'Attention',
            color: "warning",
            text: "You need a background image",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info'
          });
        }       
      });
    },
    deleteScene() {
      var self = this;
      self.showLoadingOnDeleteButton();

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Scene Deleted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
      };

      self.$ajaxDelete(self, "scene/" + self.formData.id, onSuccess, onFinally);
    },
    showLoadingOnButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addupdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnDeleteButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnList(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$parent.$el,
        scale: 1
      });
    },
    updateApproach() {
      if((this.formData.isUsedByDialog || this.formData.isUsedByVideo || this.formData.isUsedByNavigation) && this.formData.id)
        this.openConfirm();
      else
        this.addEditScene();
    },
    openConfirm() {
      this.$emit("closeSidebar");
      var message = [];
      if(this.formData.isUsedByDialog)
        message.push(' - Dialog task(s)');
      if(this.formData.isUsedByVideo)
        message.push(' - Video task(s)');
      if(this.formData.isUsedByNavigation)
        message.push(' - Navigation map(s)');

      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: `Attention`,
        text: 'The selected scene is being used in one or more:\n' + message.join("\n") + '.\n\nAre you sure you want to update it?',
        accept: this.addEditScene,
        acceptText: "Yes, update",
        cancelText: "No, cancel"
      })
    },
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}

</style>
